import { analyticsService } from "@shared/services/analytics";
import window from "@shared/utils/app-window.ts";

const shouldSkip =
  navigator.userAgent.includes("Electron") ||
  navigator.userAgent.includes("Cypress") ||
  import.meta.env.MODE === "test";

if (window.FULLSTORY_ORG_ID && !shouldSkip) {
  analyticsService.init();
}
